module.exports = __webpack_public_path__ + "static/media/AboutAlAin@2x.935dc972.jpg";